import { Link } from "react-router-dom";

export const Navbar = () => {
  return (
    <header>
      <nav>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">Over Ons</Link></li>
          <li><a href="mailto:amigosgitarosinfo@gmail.com">Contact</a></li>
        </ul>
      </nav>
    </header>
  );
};
